import FormLoading from './FormLoading';
import FormErrorsArray from './FormErrorsArray';

function FormProviderRenderer({
  message = 'Loading',
  loading,
  errors,
  children,
}) {
  if (loading) {
    return <FormLoading>{message}</FormLoading>;
  }

  if (Array.isArray(errors)) {
    if (errors.length > 0) {
      return <FormErrorsArray errors={errors} />;
    }
  } else if (errors) {
    return <FormErrorsArray errors={[{ message: JSON.stringify(errors) }]} />;
  }
  return children;
}

export default FormProviderRenderer;
